import EntityAudits from "@/components/EntityAudits.vue";
import { LE } from "@/constants/enums";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityLocations } from "@modernary/mui/components/location";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

const names = {
  incidents: "Incident.Incident",
  list: "Incident.Incidents",
  new: "Incident.IncidentNew",
  base: "Incident.IncidentBase",
  view: "Incident.IncidentView,",
  notes: "Incident.IncidentNotes",
  noteEdit: "Incident.IncidentNoteEdit",
  noteNew: "Incident.IncidentNoteNew",
  locations: "Incident.IncidentLocations",
  edit: "Incident.IncidentEdit",
  editBcState: "Incident.IncidentEditBcStates",
  editStatus: "Incident.IncidentEditStatus",
  substancesChildList: "Incident.IncidentSubstances",
  substanceEdit: "Incident.IncidentSubstanceEdit",
  substanceNew: "Incident.IncidentSubstanceNew",
  substanceSelect: "Incident.IncidentSubstanceNewSelect",
  documents: "Incident.IncidentDocuments",
  documentEdit: "Incident.IncidentDocumentEdit",
  documentNew: "Incident.IncidentDocumentNew",
  audit: "Incident.IncidentAudit",
};

export { names as IncidentRouteNames };

const IncidentRoutes: RouterOptions["routes"] = [
  {
    path: "/incidents",
    name: names.incidents,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Incidents",
        },
        component: () => import("@/views/incident/IncidentList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/incident/IncidentBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Incident New", isNew: true },
            component: () => import("@/views/incident/IncidentCreate.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/incident/IncidentBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Incident View" },
            component: () => import("@/views/incident/IncidentView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Incident Edit", isForm: true },
            component: () => import("@/views/incident/IncidentEdit.vue"),
          },
          {
            path: "editBcState",
            name: names.editBcState,
            meta: { title: "Incident BC/State Edit", isForm: true },
            component: () => import("@/views/incident/IncidentBcStatesEdit.vue"),
          },
          {
            path: "editStatus",
            name: names.editStatus,
            meta: { title: "Incident Status Edit", isForm: true },
            component: () => import("@/views/incident/IncidentStatusEdit.vue"),
          },
          {
            path: "incidentSubstance",
            name: names.substancesChildList,
            meta: { title: "Incident Substances" },
            component: () => import("@/views/incident/SubstanceChildList.vue"),
          },
          {
            path: "incidentSubstance/:incidentSubstanceId(\\d+)",
            name: names.substanceEdit,
            meta: { title: "Incident Substance Edit", isForm: true },
            component: () => import("@/views/incident/SubstanceEdit.vue"),
          },
          {
            path: `incidentSubstance/new/:categoryMurn(${LE.SubstanceCategory})`,
            name: names.substanceNew,
            meta: { title: "Incident Substance New", isForm: true },
            component: () => import("@/views/incident/SubstanceEdit.vue"),
          },
          {
            path: "incidentSubstance/select",
            name: names.substanceSelect,
            meta: { title: "Incident Substance Category", isForm: true },
            component: () => import("@/views/incident/SubstanceSelect.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Incident Notes" },
            component: {
              render: () => <EntityNotes idField="incidentId" routeNamePrefix="Incident.IncidentNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Incident Note Edit", isForm: true },
            component: () => import("@/views/incident/IncidentNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Incident Note New", isForm: true },
            component: () => import("@/views/incident/IncidentNote.vue"),
          },
          {
            path: "locations",
            name: names.locations,
            meta: { title: "Incident Locations" },
            component: {
              render: () => <EntityLocations murnResourceType="incident" />,
            },
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Incident Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="incident" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Incident Document Edit", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="incident" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Incident Document New", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="incident" />,
            },
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Incident Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Incident" />,
            },
          },
        ],
      },
    ],
  },
];
export default IncidentRoutes;
